<template>
  <v-container>
    <v-tab-item class="pb-0" eager>
      <first-tab @stepReleased="$emit('step-observer', { step: 0, complete: $event })" />
    </v-tab-item>
    <v-tab-item class="pb-0" eager>
      <second-tab @stepReleased="$emit('step-observer', { step: 1, complete: $event })" />
    </v-tab-item>
    <v-tab-item class="pb-0" eager>
      <third-tab @stepReleased="$emit('step-observer', { step: 2, complete: $event })" />
    </v-tab-item>
  </v-container>
</template>

<script>
  export default {
    components: {
      FirstTab: () => import('@/components/simulacoesLaudosIncrementais/tabs/FirstTab.vue'),
      SecondTab: () => import('@/components/simulacoesLaudosIncrementais/tabs/SecondTab.vue'),
      ThirdTab: () => import('@/components/simulacoesLaudosIncrementais/tabs/ThirdTab.vue')
    },

    emits: ['step-observer'],

    methods: {
      exportData() {
        const vuexData = this.$store.state.simulacaoLaudoIncremental;

        return {
          /* FirstTab */
          id: this.$route.params.id ? this.$route.params.id : null,
          titulo: vuexData.titulo,
          possui_obra: vuexData.possuiObra,
          possui_material: vuexData.possuiMaterial,
          deprecia_mes: vuexData.depreciaMes,
          vlr_almoxarifado_em_operacao: vuexData.vlrAlmoxarifado,
          data_base: vuexData.aisDataBase,
          origem_dados_ais: vuexData.origemDadosAis,
          data_imobilizacao_inicio: vuexData.dataImobilizacaoInicio,
          data_imobilizacao_fim: vuexData.dataImobilizacaoFim,
          arquivo_base_contabil_id: vuexData.arquivoBaseContabil.id ?? null,
          arquivo_base_contabil_delimitador: vuexData.arquivoBaseContabil.delimitador ?? null,
          arquivo_base_contabil_involucro: vuexData.arquivoBaseContabil.involucro ?? null,
          arquivo_base_contabil_escape: vuexData.arquivoBaseContabil.escape ?? null,
          arquivo_ros_val_id: vuexData.arquivoRosVal.id ?? null,
          arquivo_ros_val_delimitador: vuexData.arquivoRosVal.delimitador ?? null,
          arquivo_ros_val_involucro: vuexData.arquivoRosVal.involucro ?? null,
          arquivo_ros_val_escape: vuexData.arquivoRosVal.escape ?? null,
          arquivo_ia_id: vuexData.arquivoIa.id ?? null,
          arquivo_ia_delimitador: vuexData.arquivoIa.delimitador ?? null,
          arquivo_ia_involucro: vuexData.arquivoIa.involucro ?? null,
          arquivo_ia_escape: vuexData.arquivoIa.escape ?? null,
          arquivo_obrigacoes_especiais_id: vuexData.arquivoObrigacoesEspeciais.id ?? null,
          arquivo_obrigacoes_especiais_delimitador: vuexData.arquivoObrigacoesEspeciais.delimitador ?? null,
          arquivo_obrigacoes_especiais_involucro: vuexData.arquivoObrigacoesEspeciais.involucro ?? null,
          arquivo_obrigacoes_especiais_escape: vuexData.arquivoObrigacoesEspeciais.escape ?? null,
          /* SecondTab */
          origem_dados_banco_precos: vuexData.origemDadosBancoPrecos,
          banco_preco_calculo_id: vuexData.bancoPrecos.id,
          banco_precos_materiais: vuexData.bancoPrecosMateriais,
          banco_precos_materiais_arquivo_id: vuexData.infoUploadedFileMaterial.id,
          banco_precos_materiais_delimitador: vuexData.infoUploadedFileMaterial.delimitador,
          banco_precos_materiais_involucro: vuexData.infoUploadedFileMaterial.involucro,
          banco_precos_materiais_escape: vuexData.infoUploadedFileMaterial.escape,
          banco_precos_materiais_mapeamento_arquivo: vuexData.bancoPrecosMateriais
            ? JSON.stringify(vuexData.infoUploadedFileMaterial.mapeamento)
            : null,
          banco_precos_tucagens: vuexData.bancoPrecosTucagens,
          banco_precos_tucagens_arquivo_id: vuexData.infoUploadedFileTucagem.id,
          banco_precos_tucagens_delimitador: vuexData.infoUploadedFileTucagem.delimitador,
          banco_precos_tucagens_involucro: vuexData.infoUploadedFileTucagem.involucro,
          banco_precos_tucagens_escape: vuexData.infoUploadedFileTucagem.escape,
          banco_precos_tucagens_mapeamento_arquivo: vuexData.bancoPrecosTucagens
            ? JSON.stringify(vuexData.infoUploadedFileTucagem.mapeamento)
            : null,
          /* ThirdTab */
          percentuais: JSON.stringify(vuexData.percentuais),
          excecoes_saneamento: JSON.stringify(vuexData.desconsiderarExcecoes),
          calculo_com_ca_aneel_id: vuexData.saneamentoVoc.saneamento_voc_id,
          data_simulacao_laudo: vuexData.dataSimulacaoLaudo,
          arquivo_perc_saneamento_obra_id: vuexData.arquivoPercSaneamentoObra.id,
          arquivo_perc_saneamento_obra_delimitador: vuexData.arquivoPercSaneamentoObra.delimitador,
          arquivo_perc_saneamento_obra_involucro: vuexData.arquivoPercSaneamentoObra.involucro,
          arquivo_perc_saneamento_obra_escape: vuexData.arquivoPercSaneamentoObra.escape
        };
      }
    }
  };
</script>
